import { Button } from "@/components/ui/Button";

type Props = {
  currentIndex: number;
  totalPages: number;
  isLastPage: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
  /** When set, first-page Back exits the wizard (e.g. return to landing) instead of doing nothing. */
  onExitFromFirstPage?: () => void;
};

export function IntakeNav({
  currentIndex,
  totalPages,
  isLastPage,
  isSubmitting,
  onBack,
  onNext,
  onSubmit,
  onExitFromFirstPage,
}: Props) {
  const pageLabel = totalPages > 0 ? `Page ${currentIndex + 1} of ${totalPages}` : "";
  const atFirst = currentIndex <= 0;
  const handleBackClick = () => {
    if (atFirst && onExitFromFirstPage) {
      onExitFromFirstPage();
      return;
    }
    onBack();
  };
  const backDisabled =
    isSubmitting || (atFirst && !onExitFromFirstPage);

  return (
    <div className="mt-6 flex flex-col gap-3 border-t border-[#e2e2ec] pt-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-center text-sm text-slate-600 sm:text-left">{pageLabel}</p>
      <div className="flex flex-wrap justify-center gap-2 sm:justify-end">
        <Button
          type="button"
          variant="outline"
          onClick={handleBackClick}
          disabled={backDisabled}
        >
          {atFirst && onExitFromFirstPage ? "Exit" : "Back"}
        </Button>
        {!isLastPage && (
          <Button type="button" onClick={onNext} disabled={isSubmitting}>
            Next
          </Button>
        )}
        {isLastPage && (
          <Button type="button" onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Submitting…" : "Submit"}
          </Button>
        )}
      </div>
    </div>
  );
}
